import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js"

export const useImportProduct = () => {
	const authenticatedFetch = useAuthenticatedFetch()

	return async ({ input, media, aiOrders, productUrl }) => {
		return await authenticatedFetch("/api/productImporter/importProduct", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				input,
				media,
				aiOrders: aiOrders || [],
				productUrl,
			}),
		})
			.then((response) => response.json())
			.then((json) => {
				return {
					data: json.data || null,
					errors: json.errors || [],
				}
			})
			.catch((error) => {
				return {
					data: null,
					errors: [{ message: "Unknown error code 0" }],
				}
			})
	}
}
